export default "__VITE_ASSET__DtKOEM6k__"